var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"id":"Footer"}},[_c('at-footer-services'),_c('at-footer-news-latter'),_c('at-footer-contact'),_c('at-footer-catagory'),_c('at-footer-payment'),_c('at-footer-copy-right')],1)}
var staticRenderFns = []

export { render, staticRenderFns }